module.exports = __webpack_public_path__ + "gq.dea38d5a7aa21896a120.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gq.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gq.svg
// module chunks = styles